import { VerticalDots, InfoIcon } from '../../../assets'
import {
  canCreateOrEditMasterProduct,
  checkAccessToMaster,
  checkAccessToShop,
} from '../../../utils/api'
import { convertShopToOnFleetShop } from '../../../utils/common'

export function getProductNameRenderer() {
  function ProductNameCellRenderer() {}

  const getInputCheck = (adoptionMode, selectedProducts, isParent, data, shop) => {
    const checkedText = selectedProducts.find((r) => r.id === data.id) ? 'checked' : ''
    const selectedRow = selectedProducts && selectedProducts[0]
    var blockParent = (selectedRow && !selectedRow.children) || false
    var blockChild = (selectedRow && (selectedRow.children || !selectedRow.masterId)) || false
    var blockOrphan =
      (!adoptionMode && selectedRow && (selectedRow.children || selectedRow.masterId)) || false
    var disableText = ''
    const accessToMaster = checkAccessToMaster('product')
    if (adoptionMode && !isParent && data.masterId) {
      return ''
    }
    if (!isParent) {
      const enableShop = shop.active && !shop.deleted
      const accesToShop = checkAccessToShop(shop.id, 'product')
      disableText =
        (accessToMaster || accesToShop) &&
        enableShop &&
        (data.masterId ? !blockChild : !blockOrphan)
          ? ''
          : 'disabled'
    } else {
      disableText = accessToMaster && !blockParent ? '' : 'disabled'
    }
    return `<input class="check-name" name="product-name-${
      data.id
    }" type="checkbox" ${disableText} ${
      data.productType && data.productType == 'BUNDLE' ? 'disabled' : ''
    } ${checkedText}/>`
  }

  const getInnerHTML = (inputCheck, isParent, data, value, shop) => {
    var showMoreOptions = false
    const accessToMaster = checkAccessToMaster('product')
    if (!isParent) {
      const enableShop = shop.active && !shop.deleted
      const accesToShop = checkAccessToShop(shop.id, 'product')
      showMoreOptions = (accessToMaster || accesToShop) && enableShop ? true : false
    } else {
      showMoreOptions = accessToMaster
    }

    return `<div class="container-category-name">
                    ${
                      showMoreOptions && data.productType && data.productType !== 'BUNDLE'
                        ? `<img class="vertical-dots" src="${VerticalDots}" />`
                        : `<tooltip title="You don't have the permission to edit this ${
                            isParent ? 'master' : ''
                          } product">
                        <img class="info-icon" src="${InfoIcon}" />
                        </tooltip>`
                    }
                    ${inputCheck}
                    ${
                      isParent
                        ? `<span>${value}</span><span style="font-weight:bold; margin-left:4px">(${
                            data && data.children && data.children.length
                          })</span>`
                        : `<div class="vertical-shop-name">
                        <span>${value}</span>
                        ${getShopNameSpan(shop)}
                        </div>`
                    }
                </div>`
  }

  const getShopNameSpan = (shop) => {
    if (shop.deleted) {
      return `<span style="font-weight:bold; color:red;">${shop.name || ''} (deleted)<span>`
    }

    if (!shop.active) {
      return `<span style="font-weight:bold; color:silver;">${shop.name || ''} (disabled)<span>`
    }

    return `<span style="font-weight:bold;">${shop.name || ''}<span>`
  }

  ProductNameCellRenderer.prototype.init = function (params) {
    let tempDiv = document.createElement('div')
    const { data, selectedProducts, adoptionMode, value } = params
    const accessToMaster = checkAccessToMaster('product')
    const accesToShop = checkAccessToShop(data && data.shop && data.shop.id, 'product')
    const isParent = !!data.children

    let inputCheck = getInputCheck(adoptionMode, selectedProducts || [], isParent, data, data.shop)
    let innerHTML = getInnerHTML(inputCheck, isParent, data, value, data.shop)
    tempDiv.innerHTML = innerHTML

    this.eGui = tempDiv.firstChild

    if (!adoptionMode || (isParent && adoptionMode) || (!data.masterId && adoptionMode)) {
      this.eCheck = this.eGui.querySelector('.check-name')

      this.eventListenerCheck = (event, data) => {
        params.checkEvent(event, data)
      }

      this.eCheck.addEventListener('change', (event) => {
        this.eventListenerCheck(event, data)
      })
    }

    this.eImage = this.eGui.querySelector('.vertical-dots')
    this.eventListenerImage = (event, data) => {
      params.menuEvent(event, data)
    }

    this.eImage &&
      this.eImage.addEventListener('click', (event) => {
        if (accessToMaster || accesToShop) {
          this.eventListenerImage(event, data)
        }
      })
  }
  ProductNameCellRenderer.prototype.getGui = function () {
    return this.eGui
  }
  return ProductNameCellRenderer
}



// WEBPACK FOOTER //
// ./src/components/MasterCatalog/Fields/HeaderProductName.js